const article = {
  slug: 'tenant-portal',
  title: 'What tenants see (portal)',
  section: 'Tenants',
  body: `
# The tenant portal

Tenants sign in from your facility's portal address with a **6-digit
email code** - no passwords to forget.

## What they can do

- See each unit's balance, due date, and payment history with receipts.
- **Pay online** - card, and bank/ACH if you've enabled it for the
  facility. Balances update as the processor confirms.
- **Autopay** - save a card; invoices charge automatically when issued.
  They can swap the saved card in place.
- Download their signed lease and documents.
- Update contact info; choose SMS opt-in.

## What they can't do (by default)

- Submit a move-out notice (call-the-office is the default; enable
  self-serve per facility if you want it).
- See anything about other tenants or your operator views - the portal
  is scoped hard to their own account.

> A tenant stuck on "Processing" at payment usually means the card form
> never loaded (network/browser). Their attempt is telemetry-logged -
> support can see exactly where it stopped.
`,
};

export default article;
